export default {
  consultScoring: '/scoring',
  legacy: '/public/legacy',
  faq: '/public/faq'
};
